import { IBadgeColorIcon } from '../designSystem/components/badge';
import { WorkflowState } from '../generated/types';
import { assertUnreachable } from '../util/assertUnreachable';

export function getStateBadgeColorIcon(state: WorkflowState): IBadgeColorIcon {
    switch (state) {
        case WorkflowState.Active:
            return { color: 'success', leftIcon: 'play' };
        case WorkflowState.Paused:
            return { color: 'warning', leftIcon: 'pause' };
        default:
            return assertUnreachable(state);
    }
}
